import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import notify from 'devextreme/ui/notify';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { AllegatiDipendentiService } from 'src/app/shared/services/allegati-dipendenti.service';
import { Dipendente } from 'src/app/models/dipendente';
import {
  DxButtonComponent,
  DxFileUploaderComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-popup-add-allegato-dipendente',
  templateUrl: './popup-add-allegato-dipendente.component.html',
  styleUrls: ['./popup-add-allegato-dipendente.component.scss'],
  imports: [
    DxPopupComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxFileUploaderComponent,
    DxiValidationRuleComponent,
  ],
})
export class PopupAddAllegatoDipendenteComponent extends GestArticoliBaseComponent {
  @Input() dipendente: Dipendente;
  @Output() popupAddAllegatoDipendenteEventEmitter =
    new EventEmitter<boolean>();
  nomeAllegato: string = '';
  value: any[] = [];
  loadPanelVisible = false;

  private allegatiDipService = inject(AllegatiDipendentiService);

  getSelectedFiles() {
    return this.value;
  }

  onEsciClick() {
    this.popupAddAllegatoDipendenteEventEmitter.emit(false);
  }

  allegaFile(e, files) {
    const result = e.validationGroup.validate();
    if (result.isValid) {
      const formData = new FormData();
      formData.append('file', files[0]);
      this.loadPanelVisible = true;
      this.allegatiDipService
        .allega(this.dipendente.id, this.nomeAllegato, formData)
        .subscribe({
          next: dati => {
            this.loadPanelVisible = false;
            console.log('Allegato inserito id: ' + dati);
            notify({ message: 'Allegato salvato', width: 300, shading: true });
            this.popupAddAllegatoDipendenteEventEmitter.emit(true);
          },
          error: error => {
            this.loadPanelVisible = false;
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore caricamento allegato', 'warning');
            }
          }
        });
    }
  }
}
